import { supabase } from "@/integrations/supabase/client";

/**
 * Devuelve una URL firmada (corta) para un entregable almacenado en el bucket
 * privado `deliverables`. Estrategia:
 * 1) Si la URL ya viene firmada con token, se devuelve tal cual.
 * 2) Intentar `createSignedUrl` directo (cubre super_admin y dueño).
 * 3) Fallback a la edge function `sign-deliverable-url` que valida permisos
 *    de admin/mentor por organización/cohorte y firma con service role.
 */
export async function signDeliverableUrl(stored: string): Promise<string> {
  if (!stored) throw new Error("URL vacía");

  try {
    const u = new URL(stored);
    if (u.pathname.includes("/object/sign/") && u.searchParams.get("token")) {
      return stored;
    }
    const m = u.pathname.match(/\/object\/(?:public|authenticated|sign)\/([^\/]+)\/(.+?)(?:\?.*)?$/);
    if (m) {
      const bucket = m[1];
      const path = decodeURIComponent(m[2].split("?")[0]);
      const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, 300);
      if (!error && data?.signedUrl) return data.signedUrl;
    }
  } catch {
    // ignore — caerá al fallback
  }

  const { data, error } = await supabase.functions.invoke("sign-deliverable-url", {
    body: { url: stored },
  });
  if (error) throw error;
  if (!data?.signedUrl) throw new Error("No se pudo firmar el enlace");
  return data.signedUrl as string;
}
